var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-604.000000, -496.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logs",
    transform: "translate(604.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5 L10,5 L10,6 L6,6 L6,5 Z M13,4 L3,4 L3,7 L13,7 L13,4 Z",
    id: "Fill-2290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,14 L6,14 L6,13 L10,13 L10,14 Z M3,15 L13,15 L13,12 L3,12 L3,15 Z",
    id: "Fill-2291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,16 L2,16 L2,3 L14,3 L14,16 Z M14,0 L2,0 C0.897,0 0,0.898 0,2 L0,17 C0,18.103 0.897,19 2,19 L14,19 C15.103,19 16,18.103 16,17 L16,2 C16,0.898 15.103,0 14,0 L14,0 Z",
    id: "Fill-2292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 L6,10 L6,9 L10,9 L10,10 Z M3,11 L13,11 L13,8 L3,8 L3,11 Z",
    id: "Fill-2293"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.9541c7f7262dbaf6e3c8089443971830.svg";
export { ForwardRef as ReactComponent };